import { createSelector } from '@reduxjs/toolkit';
import { isAvailableRegion, NonEmptyArray } from '../../../../packages/JsonQuery';
import { selectEarlyAccess, selectJsonQuery } from 'shared/selectors/jsonQuery';
import { SPB_ID } from 'shared/constants/regions';
import { IConfig } from '@cian/config/shared';
import { NBSP } from 'shared/constants/symbols';

export const selectEarlyAccessFilter = (config: IConfig) => {
  const enabled = config.get<boolean>('BX.EarlyAccess.Enabled');
  const availableRegions = config.get<NonEmptyArray<number>>('BX.EarlyAccess.AvailableRegions') || [SPB_ID];

  return createSelector([selectEarlyAccess, selectJsonQuery], (value, jsonQuery) => ({
    label: 'Ранний доступ',
    description: `Объявления от${NBSP}собственников, которые недавно\nопубликовали. Просмотр контактов — платный.`,
    value: Boolean(value),
    visible: enabled && isAvailableRegion(availableRegions)(jsonQuery),
  }));
};
